import {EntityService} from "@/model/service/entity-service"
import {Address} from "@/model/entity/address/address"
import {AxiosPromise} from "axios"
import {Filter} from "@/model/dto/filter"
import {Page} from "@/model/dto/page"

class AddressService extends EntityService<Address> implements IAddressService {
  constructor() {
    super("address", Address)
  }

  getPage(page: number, rows: number, filters: Filter[]): AxiosPromise<Page<Address>> {
    return super.getPage(page, rows, filters).then(response => {
      response.data.content.forEach(item => {
        (item.country as any).i18nKey = "entity.country." + item.country.isoCodeAlpha2
      })
      return response
    })
  }

  fuzzySearch(input: string): AxiosPromise<Address[]> {
    return this.$http.get(this.path + "/fuzzy/" + input)
  }

  fuzzySearchPickup(input: string): AxiosPromise<Address[]> {
    return this.$http.get(this.path + "/fuzzy/pickup/" + input)
  }

  deleteAll(): AxiosPromise<any> {
    return this.$http.delete(this.path + "/delete_all")
  }
}

export interface IAddressService extends EntityService<Address> {
  fuzzySearch(input: string): AxiosPromise<Address[]>
  fuzzySearchPickup(input: string): AxiosPromise<Address[]>

  deleteAll(): AxiosPromise<any>
}

const service = new AddressService()

export const addressService = service
